import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto', color: '#333', lineHeight: '1.6' }}>
      <h1>Пользовательское соглашение</h1>
      <p>Последнее обновление: 15 июля 2026 г.</p>
      <p>Настоящее Соглашение регулирует отношения между проектом <strong>REALWORK</strong> (далее — Администрация) и пользователем сети Интернет (далее — Пользователь), возникающие при использовании веб-сайта и сервисов REALWORK.</p>
      
      <h3>1. Предмет соглашения</h3>
      <p>REALWORK предоставляет Пользователю доступ к платформе для выполнения задач, взаимодействия с сервисами и цифрового контента. Использование платформы означает полное согласие Пользователя с настоящим Соглашением.</p>
      
      <h3>2. Права и обязанности сторон</h3>
      <ul>
        <li>Пользователь обязуется предоставлять достоверную информацию при регистрации и не использовать сервис в противоправных целях.</li>
        <li>Администрация имеет право изменять условия Соглашения и ограничивать доступ к сервису в случае нарушения правил.</li>
      </ul>

      <h3>3. Ограничение ответственности</h3>
      <p>Сервис предоставляется по принципу "как есть" (as is). Администрация не несет ответственности за временные технические сбои, повлекшие за собой задержки в работе платформы.</p>
    </div>
  );
};

export default TermsOfService;